<template>
  <div class="main">
    <screen-header
      :updateTime="updateTime"
      @update-data="updateData"
    ></screen-header>
    <div class="main-content">
      <div class="stage-basic">
        <div class="stage-basic-title">
          <img src="../../assets/big-screen/city-basic-left.png" alt="" />
          <span class="city-basic-title-font"
            >{{ schoolName }} 基本情况统计</span
          >
          <img src="../../assets/big-screen/city-basic-right.png" alt="" />
        </div>
        <div class="top-select">
          <div class="stage-select">
            <div style="line-height: 18px">
              <span>选择年级：</span>
              <span
                :class="
                  grade === item.value ? 'school-stage active' : 'school-stage'
                "
                v-for="item in grades"
                :key="item.value"
                @click="changeGrade(item)"
                >{{ item.name }}</span
              >
            </div>
          </div>
          <div class="stage-data">
            <el-row>
              <el-col :span="4">
                <span>班级(总数)</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{
                    pageData.totalClassCount || 0
                  }}</span>
                  <span>个</span>
                </p>
              </el-col>
              <el-col :span="4">
                <span>班级(55人以上)</span>
                <p style="margin-top: 10px">
                  <span class="special-data-font">{{
                    pageData.largeClassCount || 0
                  }}</span>
                  <span>个</span>
                </p>
              </el-col>
              <el-col :span="4" v-if="!grade">
                <span>教师</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{
                    pageData.teacherCount || 0
                  }}</span>
                  <span>人</span>
                </p>
              </el-col>
              <el-col :span="4">
                <span>学生</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{
                    pageData.studentCount || 0
                  }}</span>
                  <span>人</span>
                </p>
              </el-col>
              <el-col :span="4">
                <span>男生</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{ pageData.boyCount || 0 }}</span>
                  <span>人</span>
                </p>
              </el-col>
              <el-col :span="4">
                <span>女生</span>
                <p style="margin-top: 10px">
                  <span class="data-font">{{ pageData.girlCount || 0 }}</span>
                  <span>人</span>
                </p>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="table">
          <div class="analysis">
            <span class="table-title">班级人员统计</span>
            <el-select
              placeholder="请选择"
              size="medium"
              class="analysis-select"
              v-model="grade1"
              @change="changeGrade1"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in tableOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <el-row class="table-row scroll">
            <el-col :span="24">
              <el-table
                :data="tableData"
                size="medium"
                border
                :header-row-style="{ color: '#fff' }"
                :row-style="{ height: '40px' }"
                class="home-table"
              >
                <el-table-column prop="id" label="序号" width="120">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column prop="className" label="班级">
                </el-table-column>
                <el-table-column prop="studentNumber" label="班级人数">
                  <template slot-scope="scope">
                    <span
                      :class="Number(scope.row.studentNumber) > 55 ? 'red' : ''"
                      >{{ scope.row.studentNumber }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="boyCount"
                  label="男生数"
                ></el-table-column>
                <el-table-column
                  prop="girlCount"
                  label="女生数"
                ></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ScreenHeader from '@/components/big-screen/ScreenHeader'

export default {
  props: [],

  components: {
    ScreenHeader
  },

  data() {
    return {
      grade: null,
      stages: [
        {
          name: '小学',
          value: 1,
          options: [
            {
              name: '全校',
              value: null
            },
            {
              name: '一年级',
              value: 1
            },
            {
              name: '二年级',
              value: 2
            },
            {
              name: '三年级',
              value: 3
            },
            {
              name: '四年级',
              value: 4
            },
            {
              name: '五年级',
              value: 5
            },
            {
              name: '六年级',
              value: 6
            }
          ]
        },
        {
          name: '初中',
          value: 2,
          options: [
            {
              name: '全校',
              value: null
            },
            {
              name: '初一年级',
              value: 7
            },
            {
              name: '初二年级',
              value: 8
            },
            {
              name: '初三年级',
              value: 9
            }
          ]
        },
        {
          name: '高中',
          value: 3,
          options: [
            {
              name: '全校',
              value: null
            },
            {
              name: '高一年级',
              value: 10
            },
            {
              name: '高二年级',
              value: 11
            },
            {
              name: '高三年级',
              value: 12
            }
          ]
        }
      ],
      grades: [],
      pageData: {},
      tableData: [],
      grade1: null,
      updateTime: '',
      tableOptions: []
    }
  },

  watch: {},

  computed: {
    schoolName() {
      return this.$store.state.user.school
    }
  },

  mounted() {
    this.initGrades()
  },

  methods: {
    initGrades() {
      let stage = this.$store.state.user.schoolStage
      let temp = _.filter(this.stages, { value: stage })
      this.grades = temp && temp.length > 0 && temp[0].options
      this.tableOptions = _.cloneDeep(this.grades).slice(
        1,
        _.cloneDeep(this.grades).length
      )
      this.grade1 = this.tableOptions[0].value
      this.grade = null
      this.initData(this.grade1)
    },

    changeGrade(item) {
      this.grade = item.value
      this.initPageData(item.value)
    },

    changeGrade1(val) {
      this.initTableData(val)
    },

    updateData() {
      this.$xhrGet(`/acc/summary/update`).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.initData(this.grade1)
        }
      })
    },

    initData(grade) {
      // 更新时间
      this.$xhrGet(`/acc/summary/update/time`).then(rs => {
        this.updateTime = rs.data
      })
      this.initPageData(this.grade)
      this.initTableData(grade)
    },

    initPageData(val) {
      // 获取基本情况
      this.$xhrGet(`/acc/summary/school`, { grade: val }).then(rs => {
        this.pageData = rs.data
      })
    },

    initTableData(val) {
      // 获取表格
      this.$xhrGet(`/acc/summary/school/grade/${val}`).then(rs => {
        this.tableData = rs.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;
  background: url("../../assets/big-screen/bg.png") center no-repeat;
  background-size: 100% 100%;
  filter: saturate(0.7);
}
.main-content {
  width: calc(100% - 80px);
  height: calc(100% - 80px - 4.2vw);
  padding: 40px;
}
.stage-basic {
  float: right;
  width: 100%;
  height: 100%;
  margin-left: 40px;
  background: url("../../assets/big-screen/home-right-bg.png") center no-repeat;
  background-size: 100% 100%;
}
.stage-basic-title {
  height: 30px;
  margin-top: 30px;
  text-align: center;
  vertical-align: middle;
}
.city-basic-title {
  height: 30px;
  margin-top: 30px;
  text-align: center;
  vertical-align: middle;
}
.city-basic-title-font {
  display: inline-block;
  margin: 0 12px;
  font-size: 1.25vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #41f9ff;
}
.city-basic-data {
  margin-top: 45px;
  padding: 0 30px;
  font-size: 0.8vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.data-font {
  font-size: 1.25vw;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: #3df9ff;
}
.special-data-font {
  font-size: 1.25vw;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: #ff6666;
}
.top-select {
  width: calc(100% - 120px);
  height: 120px;
  margin: 30px 40px 15px 40px;
  padding: 20px;
  background-color: rgba(35, 113, 232, 0.37);
  border-radius: 2px;
  font-size: 0.8vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.school-stage {
  padding-right: 15px;
  cursor: pointer;
}
.stage-select {
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.stage-select .active {
  color: #43f9ff;
}
.stage-data {
  padding: 30px;
}
.table {
  height: calc(100% - 325px);
  border-radius: 2px;
  margin: 30px 40px 15px 40px;
  background-color: rgba(35, 113, 232, 0.37);
}
.table-row {
  height: calc(100% - 60px);
  overflow: auto;
}
/deep/ .el-table {
  background-color: rgba(35, 113, 232, 0.17);
  color: #fff;
}
.el-table /deep/ tr,
.el-table /deep/ th,
/deep/ .cell {
  background-color: transparent !important;
}
// /deep/ tr {
//   pointer-events: none;
// }
/deep/ .el-table__body tr:hover > td {
  background-color: rgba(35, 113, 232, 0.17) !important;
}
/deep/ .el-table__body tr.hover-row > td {
  background-color: rgba(35, 113, 232, 0.37) !important;
}
/deep/ .el-table {
  border-color: transparent !important;
}
.home-table /deep/ td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}
.home-table /deep/ th {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}
// 去掉表格单元格边框
/deep/ .home-table th {
  border: none;
}
/deep/ .home-table td,
.home-table th.is-leaf {
  border: none;
}
// 表格最外边框
/deep/ .el-table--border,
.el-table--group {
  border: none;
}
// 头部边框
/deep/ .home-table thead tr th.is-leaf {
  border: none;
}
/deep/ .home-table thead tr th:nth-last-of-type(2) {
  border: none;
}
// 表格最外层边框-底部边框
/deep/ .el-table--border::after,
.el-table--group::after {
  width: 0;
}
/deep/ .home-table::before {
  width: 0;
}
/deep/ .home-table .el-table__fixed-right::before,
.el-table__fixed::before {
  width: 0;
}
// 表格有滚动时表格头边框
/deep/ .el-table--border th.gutter:last-of-type {
  border: none;
}

.table-title {
  font-size: 1vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #43f9ff;
}
/deep/ .el-input__inner {
  background: #184e9d;
  color: #fff;
}

.analysis {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 60px;
  padding: 20px;
  position: relative;
}
.analysis-select {
  position: absolute;
  width: 160px;
  height: 40px;
  right: 20px;
}
/deep/ .el-select-dropdown.el-popper {
  background: #184e9d;
  .el-select-dropdown__item {
    color: #fff;
  }
  .selected {
    background: #2371e8;
    opacity: 1 !important;
  }
  .hover {
    background: #2371e8;
    opacity: 0.45;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/big-screen/SchoolAnalysis.vue